var lang = {
    Gen: {
        animals: {
            en: 'Animals',
            th: 'สัตว์เลี้ยง'
        },
        petfoods: {
            en: 'Petfoods',
            th: 'อาหารสัตว์เลี้ยง'
        },
        supplies: {
            en: 'Supplies',
            th: 'อุปกรณ์'
        },
        stores: {
            en: 'Stores',
            th: 'ร้านค้า'
        },
        manual:{
            en: 'Manual',
            th: 'คู่มือ'
        },
        sellWithUs: {
            en: 'Sell with us',
            th: 'เริ่มต้นร้านค้ากับเรา'
        },
        home: {
            en: 'Home',
            th: 'หน้าแรก'
        },
        goBack: {
            en: 'Back',
            th: 'ย้อนกลับ'
        },
        all: {
            en: 'All',
            th: 'ทั้งหมด'
        },
        description: {
            en: 'Description',
            th: 'รายละเอียด'
        },
        report: {
            en: 'Report',
            th: 'รายงาน'
        },
        upload: {
            en: 'Upload',
            th: 'อัพโหลด'
        },
        save: {
            en: 'Save',
            th: 'บันทึก'
        },
        close: {
            en: 'Close',
            th: 'ปิด'
        },
        cancel: {
            en: 'Cancel',
            th: 'ยกเลิก'
        },
        delete: {
            en: 'Delete',
            th: 'ลบ'
        },
        confirm: {
            en: 'Confirm',
            th: 'ยืนยัน'
        },
        add: {
            en: 'Add',
            th: 'เพิ่ม'
        },
        edit: {
            en: 'Edit',
            th: 'แก้ไข'
        },
        loading: {
            en: 'Loading',
            th: 'กำลังโหลด'
        },
        product: {
            en: 'Product',
            th: 'สินค้า'
        },
        optional: {
            en: 'Optional',
            th: 'หากมี'
        },
        rowsPerPage: {
            en: 'Rows per page :',
            th: 'รายการต่อหน้า :'
        },
        search: {
            en: 'Search',
            th: 'ค้นหา'
        }
    },
    UserMenu: {
        sellPet: {
            en: 'Sell pet',
            th: 'เพิ่มรายการสินค้า'
        },
    },
    MyAccount: {
        myProfile: {
            en: 'My Profile',
            th: 'บัญชีของฉัน'
        },
        editAccountManageYourPersonalInformation: {
            en: 'Edit Account Manage your personal information',
            th: 'แก้ไขบัญชี และ จัดการข้อมูลส่วนบุคคล'
        },
        firstname: {
            en: 'Firstname',
            th: 'ชื่อจริง'
        },
        lastname: {
            en: 'Lastname',
            th: 'นามสกุล'
        },
        displayname: {
            en: 'Displayname',
            th: 'Displayname'
        },
        birthDate: {
            en: 'Date of Birth',
            th: "วันเกิด"
        },
        gender: {
            en: 'Gender',
            th: 'เพศ'
        },
        male: {
            en: 'Male',
            th: 'ชาย'
        },
        female: {
            en: 'Female',
            th: 'หญิง'
        },
        other: {
            en: 'Other',
            th: 'อื่นๆ'
        },
    },
    CreateStore: {
        createStore: {
            en: 'Create Store',
            th: 'สร้างร้านค้า'
        },
        pleaseChooseYourBank: {
            en: 'Please choose your bank',
            th: 'โปรดเลือกธนาคารของคุณ'
        },
        bankAccountNumber: {
            en: 'Bank account number',
            th: 'เลขบัญชีธนาคาร'
        },
        uploadIdentityCard: {
            en: 'Upload Identity Card',
            th: 'อัพโหลดภาพบัตรประจำตัวประชาชน'
        },
        uploadBookbankImage: {
            en: 'Upload Bookbank image',
            th: 'อัพโหลดภาพหน้าสมุดบัญชีธนาคาร'
        },
        agreeWithTerms: {
            en: 'Agree with terms and conditions',
            th: 'ยอมรับเงื่อนไขและข้อตกลง'
        },
    },
    MyStore: {
        myStore: {
            en: 'My Store',
            th: 'ร้านค้าของฉัน'
        },
        previewMyStore: {
            en: 'Preview My Store',
            th: 'ดูหน้าร้านค้า'
        },
        editStoreManageYourStoreInformation: {
            en: 'Edit Store, Manage your store information',
            th: 'แก้ไข และ จัดการข้อมูลร้านค้า'
        },
        storeName: {
            en: 'Store Name',
            th: 'ชื่อร้านค้า'
        },
        storeLocation: {
            en: 'Store Location',
            th: 'ที่ตั้งร้านค้า'
        },
        storeContact: {
            en: 'Store Contact',
            th: 'ช่องทางการติดต่อ'
        },
        aboutStore: {
            en: 'About Store',
            th: 'เกี่ยวกับร้านค้า'
        },
        owner: {
            en: 'Owner',
            th: 'เจ้าของร้าน'
        },
        joined: {
            en: 'Joined',
            th: 'เข้าร่วม'
        }
    },
    ProductList: {
        sort: {
            by: {
                en: 'Sort By',
                th: 'เรียงรายการ'
            },
            priceLowToHigh: {
                en: 'Price low to high',
                th: 'ราคาจากน้อยไปมาก'
            },
            priceHighToLow: {
                en: 'Price high to low',
                th: 'ราคาจากมากไปน้อย'
            },
            recently: {
                en: 'Recently',
                th: 'ล่าสุด'
            }
        },
    },
    ProductView: {
        contactStore: {
            en: 'Contact Store',
            th: 'ติดต่อร้านค้า'
        },
    },
    Product: {
        productManagement: {
            en: 'Product Management',
            th: 'จัดการรายการสินค้า'
        },
        tableAction: {
            en: 'Hold|Edit|Del',
            th: ''
        },
        noDataAvailable: {
            en: 'No data available',
            th: 'ไม่มีข้อมูล'
        },
        loadingItems: {
            en: 'Loading items...',
            th: 'กำลังโหลดรายการ...'
        },
        type: {
            en: 'Type',
            th: 'หมวดหมู่ย่อย'
        },
        category: {
            en: 'Category',
            th: 'หมวดหมู่'
        },
        title: {
            en: 'Title',
            th: 'ชื่อรายการ'
        },
        image: {
            en: 'Image',
            th: ''
        },
        stock: {
            en: 'Stock',
            th: 'จำนวนในคลัง'
        },
        view: {
            en: 'View',
            th: ''
        },
        price: {
            en: 'Price',
            th: 'ราคา'
        },
        shippingPrice: {
            en: 'Shipping Price',
            th: 'ค่าจัดส่ง'
        },
        birth: {
            en: 'Birth',
            th: 'วันเกิด'
        },
        weight: {
            en: 'Weight',
            th: 'น้ำหนัก'
        },
        sex: {
            en: 'Sex',
            th: 'เพศ'
        },
        male: {
            en: 'Male',
            th: 'ผู้'
        },
        female: {
            en: 'Female',
            th: 'เมีย'
        },
        unknown: {
            en: 'Unknown',
            th: 'ไม่ระบุ'
        },
        diet: {
            en: 'Diet',
            th: 'ประเภทอาหาร'
        },
        subType: {
            en: (sub) => sub.title,
            th: (sub) => sub.titleTh || sub.title
        }
    },
    AddProduct: {
        addProduct: {
            en: 'Add Product',
            th: 'เพิ่มสินค้า'
        },
        productName: {
            en: 'Product Name',
            th: 'ชื่อสินค้า'
        },
        productDescription: {
            en: 'Product Description',
            th: 'รายละเอียดสินค้า'
        },
        addImages: {
            en: (num) => `Add images(${num} max ),`,
            th: (num) => `เพิ่มรูป (มากสุด ${num} รูป ),`
        },
        selectImage: {
            en: 'Select a preview image',
            th: 'เลือกรูปปกสินค้า'
        },
        priceAfterDiscount: {
            en: 'Price after discount',
            th: 'ราคาหลังลดแล้ว'
        },
        productPreview: {
            en: 'Product Item Preview',
            th: 'ตัวอย่างรายการสินค้า'
        }
    },
    Auth: {
        login: {
            en: 'Login',
            th: 'ลงชื่อเข้าใช้'
        },
        signup: {
            en: 'Sign Up',
            th: 'สมัคร'
        },
        logout: {
            en: 'Logout',
            th: 'ออกจากระบบ'
        },
        email: {
            en: 'Email',
            th: 'อีเมล'
        },
        password: {
            en: 'Password',
            th: 'รหัสผ่าน'
        },
        forgetPassword: {
            en: 'Forgotten Password?',
            th: 'ลืมรหัสผ่าน?'
        },
        chooseNewPassword: {
            en: 'Choose your new password',
            th: 'ตั้งรหัสผ่านใหม่'
        }
    },
    Manual: {
        title: {
            en: 'Guide: How to use our platform',
            th: 'คำแนะนำการใช้งานเบื้องต้น'
        }
    },
    Home: {
        title: {
            en: 'Platform for buying and selling pets and equipment',
            th: 'แพลตฟอร์มสำหรับซื้อขาย สัตว์เลี้ยง และ อุปกรณ์'
        },
        shopCategory: {
            en: 'Shop Category',
            th: 'หมวดหมู่ร้านค้า'
        },
        createStore: {
            en: 'Create shop now,',
            th: 'เปิดร้านตอนนี้เลย'
        },
        free: {
            en: `It's free`,
            th: 'ฟรี'
        }
    },
    space: {
        en: ' ',
        th: ''
    },
    lang: 'th'
}

export default lang;